var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.63 0L14.9999 2.36991L13.1933 4.17737L10.8234 1.80745L12.63 0ZM3.94983 11.0501H6.31974L12.0763 5.2936L9.70635 2.92368L3.94983 8.6802V11.0501Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6395 13.4201H4.07467C4.05413 13.4201 4.0328 13.428 4.01226 13.428C3.98619 13.428 3.96013 13.4208 3.93327 13.4201H1.57994V2.36046H6.98887L8.56882 0.780518H1.57994C0.708604 0.780518 0 1.48833 0 2.36046V13.4201C0 14.2922 0.708604 15 1.57994 15H12.6395C13.0586 15 13.4604 14.8335 13.7567 14.5372C14.053 14.2409 14.2195 13.8391 14.2195 13.4201V6.57259L12.6395 8.15253V13.4201Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.536c35f9605da87a14ed3fd06d58a036.svg";
export { ForwardRef as ReactComponent };